// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowSitePageContainer_root__15YY_","tabsContainer":"ShowSitePageContainer_tabsContainer__3I3Xp"};